export default "__VITE_ASSET__Cf4KhbYd__"